import { useState } from 'react';
import InputForm from '../../../../InputT';
import { useTranslation } from 'react-i18next';
import ParamsPicklist from '../../../../../Types/ParamsPicklist';
import DataType from '../../../../../Types/DataTablePiclist';
import { Backdrop, Box, CircularProgress } from '@mui/material';
import SearchInput from '../../../../SearchInput';
import SearchModal from '../../../../SearchModal';
import { ColumnsType } from 'antd/es/table';
import Table from '../../../../TableResizable';
import { MonetizationOnTwoTone, FoodBank, Numbers } from '@mui/icons-material';
import Utilisateur from '../../../../../Models/Utilisateur';
import { useAuthHeader, useAuthUser } from '../../../../../Services/Auth/sessionAuth';
import ReformatDate from '../../../../../Functions/Traitement/ReformatDate';
import Cheque from '../../../../../Models/Cheque';
import SelectOption from '../../../../SelectOption';
import { Crypter } from '../../../../../Functions/Security/Crypter';
import axios from 'axios';
import formatNumber from '../../../../../Functions/Traitement/FormatNumber';

const Swal = require('sweetalert2');
let Link = require('../../../../../Data/Data.json');


const Tab1 = (props: { etatG: boolean, form?: any, DataCheque: Cheque[], OnModif: Function }) => {

    const datas: DataType[] = [];
    //const {t,i18n}=useTranslation();
    const { t, i18n } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [Filtre, setFiltre] = useState<string>("1");
    const auth = useAuthUser();
    const user: Utilisateur = JSON.parse(JSON.stringify(auth()))
    const authHeader = useAuthHeader();

    const HandlerChangeBank = () => {
        //setLoad(true);
        let init = props.form.getFieldValue("BANCLT");

        var data = { CodeAgence: "", Table: "BANQUE", Colonne1: "CODCPT", Colonne2: "LIBELL", Colagence: "001", Init: init, choix: 33 }
        //console.log(Crypter.encrypt(JSON.stringify(data)))
        var config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: Link.ApiUrl.AnySearch,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authHeader(),
                'CypherSearch': Crypter.encrypt(JSON.stringify(data))
            }
        };

        axios(config)
            .then((response) => {
                //alert('ok')
                if (response.data) {
                    const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                    if (res.StatutCode == 200) {
                        let datas = res.Result.Table[0];

                        if (datas.length === 0) {
                            //console.log("aucun élément ");
                            //SetData(datat)
                        }
                        else {
                            props.form.setFieldsValue({ "CPTCHQRECOUVRE": datas.CPTCHQRECOUVRE, "lib_CPTCHQRECOUVRE": datas.LIBELL });
                        }
                    }
                }
                //    setLoad(false);
            }).catch((error) => {
                console.log(error)
                //setLoad(false);
                // SweetAlert.fire({title: "Error", text : error})
            })

    }

    const HandlerClient = () => {
        let NUMCLI = props.form.getFieldValue("NUMCLI");

        setFiltre(NUMCLI);
    }

    //Initialisation des parametres de recherche
    let searchOp: ParamsPicklist = { CodeAgence: '', Table: "OPERAT", Colonne1: "CODOPE", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
    let searchBanque: ParamsPicklist = { CodeAgence: user.codage, Table: "BANQUE", Colonne1: "CODCPT", Colonne2: "LIBELL", Colagence: 'AGECPT', Choix: 22 }
    let searchCompteT: ParamsPicklist = { CodeAgence: Filtre, Table: "COMPTES", Colonne1: "NUMCPT", Colonne2: "NOMCPT", Colagence: "NUMCLI", Choix: 22 }
    let searchClient: ParamsPicklist = { CodeAgence: '', Table: "CLIENT", Colonne1: "NUMCLI", Colonne2: "NOMCLI", Colagence: "101", Choix: 22 }
    // let searchCompteT: ParamsPicklist = { CodeAgence: user.codage, Table: "COMPTES", Colonne1: "NUMCPT", Colonne2: "NOMCPT", Colagence: "AGCCPT", Choix: 22 }
    const columns: ColumnsType<Cheque> = [
        {
            title: 'DateOpe',
            dataIndex: 'DATOPE',
            ellipsis: true,
            width: 100,
            render: (text: any, reccord: any) => (
                <span>
                    {ReformatDate(text)}
                </span>
            )
        }
        ,
        {
            title: 'BANQUE',
            dataIndex: 'Lib_BANQUE',
            ellipsis: true,
            width: 150,
        },
        {
            title: 'Montant',
            dataIndex: 'MONTAN',
            ellipsis: true,
            width: 130,
        },
        {
            title: 'Montant Restant',
            dataIndex: 'MONTRES',
            ellipsis: true,
            width: 100,
        },
        {
            title: 'N° Compte',
            dataIndex: 'NUMCPT',
            ellipsis: true,
            width: 200,
            // filteredValue: [SearchR],
            onFilter: (value: any, record: any) => {
                return String(record.NUMCPT)
                    .toLowerCase()
                    .includes(value.toLowerCase()) ||
                    String(record.SENSEC)
                        .toLowerCase()
                        .includes(value.toLowerCase()) ||
                    String(record.REPECE)
                        .toLowerCase()
                        .includes(value.toLowerCase()) ||
                    String(record.MONTANT)
                        .toLowerCase()
                        .includes(value.toLowerCase()) ||
                    String(record.LIBELL)
                        .toLowerCase()
                        .includes(value.toLowerCase()) ||
                    String(record.Utilis)
                        .toLowerCase()
                        .includes(value.toLowerCase()) ||
                    String(record.Motif)
                        .toLowerCase()
                        .includes(value.toLowerCase())
            }
        },
        {
            title: 'N° Chèque',
            dataIndex: 'NUMCHQ',
            ellipsis: true,
            width: 150,
        },
        {
            title: 'N° Cpt cheque',
            dataIndex: 'CPTCHC',
            ellipsis: true,
            width: 150,
        },
        {
            title: 'Cpt Client Banque',
            dataIndex: 'CPTCLT',
            ellipsis: true,
            width: 150,
        },
        {
            title: 'Remettant',
            dataIndex: 'REMETT',
            ellipsis: true,
            width: 200,
        },
        {
            title: "",
            dataIndex: 'RelObject',
            width: 1
        }
    ];

    let informationclient = {
        searchCodeOpe: {
            Titre: "Recherche Opération",
            label: "Opération",
            name: "CODOPES", params: searchOp
        },
        searchBanque: {
            Titre: "Recherche Banque",
            label: "Banque de dépot",
            name: "BANCLT", params: searchBanque
        },

        searchCompteCltCredit: {
            Titre: "Recherche Compte Client à Créditer ",
            label: "Cpte  Client à Créditer",
            name: "NUMCPTC", params: searchCompteT
        },
        searchCompteCltDebit: {
            Titre: "Recherche Compte Client à Débiter ",
            label: "Cpte  Client à Débiter",
            name: "NUMCPTD", params: searchCompteT
        },
        InputMontantEscompte: {
            label: "Montant à Escompter",
            name: "MONTANT"
        },
        InputMontantResEscompte: {
            label: "Montant Restant ",
            name: "MONTANTRES"
        },
        InputCommission: {
            label: "Commission Escompter",
            name: "COM"
        },
        InputLibOpe: {
            label: "libelle de l'opération",
            name: "Libope"
        },
        searchClient: {
            Titre: "Recherche Client",
            label: "Client ",
            name: "NUMCLI", params: searchClient
        },
        InputMontant: {
            label: "Montant à Escompter",
            name: "MONTAN"
        },
        InputRemettant: {
            label: "Remettant",
            name: "REMETT"
        },
        //Montant disponible pour le recepteur
        InputNumcheque: {
            label: "Numéro de chèque",
            name: "NUMCHQ"
        },
        InputCptClientBanque: {
            label: "Compte Client à la Banque",
            name: "CPTCLT"
        },
        InputNumbor: {
            label: "Numéro bordereau remise",
            name: "BORDER"
        },
    }

    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

    const onSelectChange = async (newSelectedRowKeys: any) => {
        // console.log('selectedRowKeys changed: ', Data[newSelectedRowKeys]);
        props.form.setFieldsValue(props.DataCheque[newSelectedRowKeys].RelObject);
        props.form.setFieldValue('DATOPE', ReformatDate(props.DataCheque[newSelectedRowKeys].DATOPE));
        props.form.setFieldValue('MONTAN', props.DataCheque[newSelectedRowKeys].MONTAN);
        props.form.setFieldValue('MONTANTRES', props.DataCheque[newSelectedRowKeys].RelObject.MONTRES);
        props.form.setFieldValue('NUMCPTC', props.DataCheque[newSelectedRowKeys].RelObject.NUMCPT);

        await HandlerClient();
        props.form.setFieldValue('lib_CODOPE', props.DataCheque[newSelectedRowKeys].RelObject.LIBECR);
        setSelectedRowKeys(newSelectedRowKeys);

        props.OnModif();


    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };


    return (
        <div className='tabItem' >
            <Box fontStyle="inherit" className='border-left border' width={"85%"} position={"absolute"} sx={{p: 1}}>
                <legend> Escompte chèque client </legend>
                  <Box fontStyle="inherit" className='border' width={"100%"} sx={{mb:1}} >
                      
                    <SearchInput dissabledLib={false}  dissabledCode notRequired form={props.form} width={3} Titre={informationclient.searchCodeOpe.Titre} label={informationclient.searchCodeOpe.label} name={informationclient.searchCodeOpe.name} Parametre={informationclient.searchCodeOpe.params} />
             
                <Box style={{ display: 'flex', marginTop: '-1%' }} >
                    <Box fontStyle="inherit" className='border-left' width={'50%'}  >
                        <SearchModal disabled={props.etatG} form={props.form} ExecuteafterSelect1={HandlerClient} width={6} Titre={informationclient.searchClient.Titre} label={informationclient.searchClient.label} name={informationclient.searchClient.name} Parametre={informationclient.searchClient.params} />
                        {/* <InputForm disabled icon={<FoodBank />} width={9} label={informationclient.InputCptClientBanque.label} name={informationclient.InputCptClientBanque.name} type='text' /> */}
                        <SelectOption Size={'middle'} width={6} label={informationclient.searchCompteCltCredit.label} name={informationclient.searchCompteCltCredit.name} Parametre={informationclient.searchCompteCltCredit.params} />
                        {/* <InputForm icon={<NightShelterOutlined />} width={9} label={informationclient.InputLibOpe.label} name={informationclient.InputLibOpe.name} type='TextArea' /> */}
                        <InputForm disabled icon={<MonetizationOnTwoTone />} money width={6} label={informationclient.InputMontantResEscompte.label} name={informationclient.InputMontantResEscompte.name} type='number' />
                    </Box>

                    <Box fontStyle="inherit" className='border-left' width={'50%'}>
                        <SearchModal disabled form={props.form} width={9} ExecuteafterSelect1={HandlerChangeBank} Titre={informationclient.searchBanque.Titre} label={informationclient.searchBanque.label} name={informationclient.searchBanque.name} Parametre={informationclient.searchBanque.params} />
                        <InputForm icon={<Numbers />} width={9} disabled label={informationclient.InputNumcheque.label} name={informationclient.InputNumcheque.name} type='number' />
                        {/* <SelectOption Size={'middle'}  width={9}    label={informationclient.searchCompteCltDebit.label} name={informationclient.searchCompteCltDebit.name} Parametre={informationclient.searchCompteCltDebit.params} /> */}
                        <InputForm icon={<FoodBank />} money width={9} label={informationclient.InputMontantEscompte.label} name={informationclient.InputMontantEscompte.name} type='number' />
                        <Box sx={{ visibility: 'hidden' }} marginTop={'-10%'} >
                            <InputForm width={9} notRequired label={"identifiant"} name={"Id"} type='text' />
                        </Box>
                      
                    </Box>
                </Box>
                  </Box>
                
                <Box fontStyle="inherit" className='border' width={"100%"} sx={{mb:1}} >
                    <Table sticky={true} columns={columns} rowSelection={{ type: 'radio', ...rowSelection, getCheckboxProps: (reccord) => ({ disabled: false }) }} size='small' style={{ width: '100%' }} pagination={false} scroll={{ y: 250, x: 1200 }} dataSource={props.DataCheque} />
                </Box>
            </Box>
            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading} >
                <CircularProgress color="inherit" />
            </Backdrop>

        </div>
    );
}
export default Tab1;
